<template>
  <section :class="pageIntroClass">
    <div class="page-intro__content">
      <div class="page-intro__logo">
        <Logo />
      </div>
      <div class="page-intro__actions">
        <div v-if="!isGameDownload" class="page-intro__text">
          <h1 class="page-intro__title">
            {{ $t("promo.intro.title") }}
          </h1>
          <h2 v-if="!isUserInProject" class="page-intro__subtitle">
            {{ $t("promo.intro.button") }}
          </h2>
        </div>
        <h2 v-if="isGameDownload" class="page-intro__download">
          <p>{{ $t("promo.intro.download_text.first") }}</p>
          <p>{{ $t("promo.intro.download_text.second") }}</p>
        </h2>
        <AuthButtons
          v-if="showAuthButtons"
          class="page-intro__buttons"
          showMgButtonOnlyForPc
          needLogout
          mgDownload
          @startDownload="onStartDownload"
        />
        <div v-else class="page-intro__main-button">
          <MainButton theme="cta" @click="onButtonClick">{{ buttonText }}</MainButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import MainButton from "@static_promo_pages/common/components/redesign/main-button/vue/MainButton.vue";
import AuthButtons from "@static_promo_pages/common/components/redesign/auth-buttons/vue/AuthButtons.vue";

import LoginAndDownloadMixin from "@static_promo_pages/common/mixins/LoginAndDownloadMixin";
import DeviceDetectionMixin from "@godweb/frontend-base/src/mixins/mobile_detection/DeviceDetectionMixin";
import Logo from "@static_promo_pages/common/components/redesign/logo/vue/Logo.vue";

export default {
  name: "PageIntro",
  components: {
    MainButton,
    AuthButtons,
    Logo,
  },
  mixins: [LoginAndDownloadMixin, DeviceDetectionMixin],
  props: {
    isGameDownload: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showAuthButtons() {
      return (!this.isUserInProject || !this.isSteamPsXboxUser) && !this.isGameDownload;
    },
    buttonText() {
      return this.isGameDownload ? this.$t("promo.intro.download_button") : this.$t("promo.intro.button");
    },
    pageIntroClass() {
      return [
        "page-intro",
        { "page-intro--auth": this.isUserInProject },
      ]
    },
  },
  watch: {
    isUserProcessed() {
      if (this.isUserInProject && this.isSteamPsXboxUser) {
        this.redirectToStore();
      }
    },
  },
  methods: {
    onButtonClick() {
      if (this.isSteamPsXboxUser) {
        this.redirectToStore();
      } else if (!this.isWindowsOs) {
        this.redirectToMGStore();
      } else {
        this.$oneLinkEventSender.sendEvent("play");
        if (!!window.__GEM) {
          this.gameDownload("", false, false);
        } else {
          document.addEventListener("GEM_loaded", () => {
            this.gameDownload("", false, false);
          });
        }
      }
    },
    onStartDownload() {
      this.$emit("startDownload");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles";
</style>
